// Libraries
import { Typography } from "@material-ui/core";
import { styled, useObserver } from "@shoothill/core";
import React, { useContext } from "react";

// Custom
import { ProjectListViewModel } from "../ProjectListViewModel";

// Styling & Images
import { DarwinPage, DarwinPageTitle, DarwinTableToolbar } from "Globals/Styles/AppStyling";
import { ProjectListModelWithAddress } from "../ProjectListModelWithAddress";
import { SHBox } from "../../../Components/Box";
import { uniqueId } from "lodash-es";
import { GlobalHistory } from "../../../index";
import { AppUrls } from "../../../AppUrls";
import { Stores, StoresContext } from "Globals/Stores";

interface Props {
    viewModel: ProjectListViewModel;
    projectDetails: ProjectListModelWithAddress | null;
}
export const InductionUserMenuView: React.FunctionComponent<Props> = (props: Props) => {
    const { projectDetails } = props;

    const storesContext = useContext<Stores>(StoresContext);

    const tiles = [
        { name: "Induction", url: AppUrls.Client.Induction.Landing },
        {
            name: "Near Miss",
            url: AppUrls.Client.Project.InductionUser.NearMiss,
        },
        { name: "Inspection", url: AppUrls.Client.Project.InductionUser.Inspection },
        { name: "Permits", url: AppUrls.Client.Project.InductionUser.Permit },
        { name: "Scaffold", url: AppUrls.Client.Project.InductionUser.Scaffold },
    ];

    const isValidProjectDetails = (details: ProjectListModelWithAddress | null): boolean => {
        return !!details && !!details.id;
    };

    const logout = (): void => {
        storesContext.Domain.AccountStore.Logout(true);
    };

    return useObserver(() => {
        const isAssigned = isValidProjectDetails(projectDetails);

        return (
            <DarwinPage>
                <DarwinPageTitle>
                    {isAssigned ? (
                        <>
                            <Typography variant="h1" color="textPrimary">
                                {projectDetails?.reference} - {projectDetails?.name}
                            </Typography>
                            <Typography variant="h2" color="textPrimary">
                                {[projectDetails?.addressLine1, projectDetails?.addressLine2, projectDetails?.city, projectDetails?.postcode].filter(Boolean).join(", ")}
                            </Typography>
                        </>
                    ) : (
                        <>
                            <Typography variant="h1" color="textPrimary">
                                You're not currently assigned to a project
                            </Typography>
                        </>
                    )}
                </DarwinPageTitle>

                <DarwinTableToolbar>
                    <SHBox height={"85vh"} display={"grid"} dr={`repeat(${isAssigned ? tiles.length + 1 : 1}, 1fr)`} showIf={isAssigned}>
                        {tiles.map((tile, index) => (
                            <CardView key={uniqueId()} number={index} title={tile.name} url={tile.url} />
                        ))}
                        <CardView key={uniqueId()} number={isAssigned ? tiles.length + 1 : 1} title={"Log out"} url={""} action={() => logout()} />
                    </SHBox>
                    <SHBox display={"grid"} dr={`repeat(${1}, 1fr)`} showIf={!isAssigned}>
                        <CardView key={uniqueId()} number={1} title={"Log out"} url={""} action={() => logout()} />
                    </SHBox>
                </DarwinTableToolbar>
            </DarwinPage>
        );
    });
};

const Tile = styled(SHBox)`
    display: grid;
    grid-template-columns: 60px 1fr;
    border: 1px solid #0095da;
    margin-bottom: 15px;
    border-radius: 10px;
    cursor: pointer;
    //height: 25%;
    .number {
        color: #0095da;
        font-size: 28px;
        font-weight: 600;
        text-align: center;
        align-self: center;
    }
    .title {
        display: flex;
        align-items: center;
        padding-left: 20px;
        color: white;
        background-color: #0095da;
        font-size: 56px;
        align-self: center;
        height: 100%;
    }
`;
interface CardProps {
    number: number;
    title: string;
    url: string;
    action?: () => void;
}

const CardView: React.FunctionComponent<CardProps> = (props: CardProps) => {
    const handleClick = () => {
        if (props.action) {
            props.action();
        } else {
            GlobalHistory.push(props.url);
        }
    };
    return (
        <Tile onClick={handleClick}>
            <SHBox className={"number"}>{props.number}</SHBox>
            <SHBox className={"title"}>{props.title}</SHBox>
        </Tile>
    );
};
